import {Component, OnInit} from '@angular/core';
import {UserManagementService} from "../../../../services/apiServices/business/user-management.service";
import {AuthenticationService} from "../../../../services/apiServices/security/authentication.service";
import {User} from "../../../../model/user";
import {CommonService} from "../../../../services/apiServices/business/common.service";
import {TranslateService} from "@ngx-translate/core";
import {ErlConfig} from "../../../../model/erl-config";

@Component({
  selector: 'app-erl-config',
  templateUrl: './erl-config.component.html',
  styleUrls: ['./erl-config.component.css']
})
export class ErlConfigComponent implements OnInit {
  currentConfig: ErlConfig;
  customerIDs: string[] = [];
  availableIDs: string[] = [];
  selectedIDs: string[] = [];
  enableForAll= false;
  currentUser: User;
  constructor(private userManagementService : UserManagementService, private authenticationService: AuthenticationService,
              private commonService : CommonService, private translateService: TranslateService) {

  }
  ngOnInit(): void {
    this.currentUser = this.authenticationService.getCurrentUser();
    this.userManagementService.getListAnalyticID().subscribe(responseID => {
      this.availableIDs = responseID;
      this.customerIDs = responseID;
      this.userManagementService.getErlConfig().subscribe(response => {
        this.currentConfig = response;
        this.enableForAll = this.currentConfig.all;
        if(!this.currentConfig.all && this.currentConfig.list){
          const tempIds = [];
          if(this.availableIDs && this.availableIDs.length > 0) {
            for (const s of this.availableIDs) {
              if (this.currentConfig.list.indexOf(s) < 0) {
                tempIds.push(s);
              }
            }
          }
          this.availableIDs = tempIds;
          this.selectedIDs = this.currentConfig.list;
        }
      });
    });

  }

  saveErlConfig() {
    const newConfig : ErlConfig = {
      all : this.enableForAll,
      list : this.enableForAll ? [] : this.selectedIDs
    };

    this.userManagementService.saveErlConfig(newConfig).subscribe(response => {
      this.commonService.addToast({
          life: 3000,
          severity: 'success',
          summary: this.translateService.instant('ERL_CONFIG.TOAST_TITLE'),
          detail: this.translateService.instant('ERL_CONFIG.TOAST_CONTENT')
      });
    });
  }
}
